const SKIP_TARGET_ATTRS = [
    'data-yoda-change-slug',
];

const SKIP_TARGET_CLASSES = [
    'yoda-change-slug',
    'wysiwyg-mention',
    'rdw-mention-link',
];

/**
 * Ensure non-in-app anchors open in a new tab.
 * Skips Yoda change-slug links and mention links (in-app navigation).
 */
export function ensureExternalLinksOpenBlank(html: string): string {
    if (!html)
        return html;

    return html.replace(/<a\b([^>]*)>/gi, (full, attrs: string) => {
        const lower = attrs.toLowerCase();

        if (SKIP_TARGET_ATTRS.some((attr) => lower.includes(attr)))
            return full;

        if (SKIP_TARGET_CLASSES.some((cls) => new RegExp(`\\bclass\\s*=\\s*["'][^"']*\\b${cls}\\b`, 'i').test(attrs)))
            return full;

        let next = attrs;

        if (/\btarget\s*=/i.test(next))
            next = next.replace(/\btarget\s*=\s*(["']).*?\1/i, 'target="_blank"');
        else
            next += ' target="_blank"';

        if (/\brel\s*=/i.test(next)) {
            next = next.replace(/\brel\s*=\s*(["'])(.*?)\1/i, (_m, q: string, value: string) => {
                const tokens = new Set(
                    String(value || '')
                        .split(/\s+/)
                        .map((t) => t.trim().toLowerCase())
                        .filter(Boolean)
                );
                tokens.add('noopener');
                tokens.add('noreferrer');
                return `rel=${q}${Array.from(tokens).join(' ')}${q}`;
            });
        } else {
            next += ' rel="noopener noreferrer"';
        }

        return `<a${next}>`;
    });
}
